<template>
<div>

    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card class="pa-2">
            <v-card-title class="text-h5 font-weight-regular">Export Price Comparison Report</v-card-title>
            <v-divider/>
            <v-card-text class="mt-4">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="12">
                            <label class="text-uppercase grey--text font-weight-bold">Ordered Date*</label>
                            <v-menu :close-on-content-click="false" :nudge-right="40" min-width="290px" offset-y
                                    transition="scale-transition" v-model="dateMenu">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field class="rounded-0 mt-3" outlined prepend-inner-icon="mdi-calendar-blank-outline"
                                                  readonly v-bind="attrs" v-model="dateFormat" v-on="on" :rules="[v => !!v || 'Ordered Date required']"/>
                                </template>
                                <v-date-picker @input="dateMenu = false" v-model="form.date"/>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="mt-2">
                <v-spacer></v-spacer>
                <v-btn class="text-capitalize white elevation-0" text @click="closeDialog">Close</v-btn>
                <v-btn class="primary px-3 text-capitalize" :loading="formLoading" dark @click="handleSubmit">Export</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <Snackbar :toaster="toaster"/>
</div>
</template>

<script>
import Constants from "../../../../Constants/Constants";
import moment from 'moment';
import axios from 'axios';
import Snackbar from "../../../../components/Common/Snackbar";
let form = { date: moment().format('YYYY-MM-DD') };
export default {
    name: "ExportByPrice",
    components: {Snackbar},
    props: ['dialog'],
    data(){
        return{
            Constants, moment,
            form: {...form},
            formLoading: false,
            dateMenu: false,
            toaster: {}
        }
    },
    computed:{
        dateFormat: {
            get () { return moment(this.form.date, 'YYYY-MM-DD').format('DD-MM-YYYY') },
            set () { this.form.date = null }
        },
    },
    methods:{
        handleSubmit(){
            if(this.$refs.form.validate()) this.exportReport()
        },
        exportReport(){
            this.formLoading = true;
            let request = { ...this.form };
            axios({method: 'POST', url: `${Constants.api_url}exportPriceComparisonExcel`, data: request, responseType: 'blob'}).then(response => {
                if(response.headers['content-type'] === 'application/json') {
                    this.toaster = {enable: true, color: 'red', message: 'No data available for selected date'};
                    return this.formLoading = false;
                }
                const a = window.document.createElement('a');
                a.href = window.URL.createObjectURL(response.data);
                a.download = 'PriceComparisonReport_' + moment().format('DD/MM/YYYY HH:mm') + '.xlsx';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                this.formLoading = false;
                this.closeDialog();
            }).catch(e => {
                this.formLoading = false;
                this.toaster = {enable:true, color:'red', message:'Export API Failed'};
                console.log('export catch error', e)
            })
        },
        closeDialog(){
            this.$refs.form.resetValidation();
            this.form = {...form};
            this.$emit('update:dialog', false);
        }
    }
}
</script>

<style scoped>

</style>